<template>
  <div class="crew-assignment-dashboard">
    <vx-card class="alert-wrapper">
      <labeled-flex-section label="船舶アラート">
        <crew-assignment-alert-card
          :title="`入替船員未登録`"
          :unit-text="`隻`"
          :alert-data="manningVesselAlert"
          :alert-setting="manningVesselAlertSetting"
          :isVesselAlert="true"
        />
      </labeled-flex-section>
    </vx-card>
    <vx-card class="alert-wrapper">
      <labeled-flex-section label="船員アラート">
        <crew-assignment-alert-card
          :title="`乗船準備`"
          :unit-text="`人`"
          :alert-data="embarkationStandbyAlert"
          :alert-setting="embarkationStandbyAlertSetting"
          :isVesselAlert="false"
        />
        <crew-assignment-alert-card
          :title="`下船準備`"
          :unit-text="`人`"
          :alert-data="disembarkationStandbyAlert"
          :alert-setting="disembarkationStandbyAlertSetting"
          :isVesselAlert="false"
        />
        <crew-assignment-alert-card
          :title="`休暇希望重複`"
          :unit-text="`人`"
          :alert-data="dayOffRequestDuplicatedAlert"
          :alert-setting="dayOffRequestDuplicatedAlertSetting"
          :isVesselAlert="false"
        />
        <crew-assignment-alert-card
          :title="`資格期限`"
          :unit-text="`人`"
          :alert-data="licenseExpiredAlert"
          :alert-setting="licenseExpiredAlertSetting"
          :isVesselAlert="false"
        />
        <crew-assignment-alert-card
          :title="`予定未入力`"
          :unit-text="`人`"
          :alert-data="crewCompatibilityAlert"
          :alert-setting="crewCompatibilityAlertSetting"
          :isVesselAlert="false"
        />
      </labeled-flex-section>
    </vx-card>
    <section-with-divider>
      <template v-slot:header>
        <div class="header-title">配乗表</div>
      </template>
      <div class="menu-button-list">
        <menu-card
          label="配乗一覧表"
          icon="view_timeline"
          @click="navigateToManningSchedule"
        />
        <menu-card
          label="船舶単位配乗表"
          icon="directions_boat"
          @click="navigateToVesselManning"
        />
        <menu-card
          label="船員単位配乗表"
          icon="person"
          @click="navigateToCrewManning"
        />
      </div>
    </section-with-divider>
    <section-with-divider>
      <template v-slot:header>
        <div class="header-title">設定</div>
      </template>
      <div class="menu-button-list">
        <!-- <menu-card
          label="配乗設定"
          description="法人に紐づく配乗の設定ができます"
          @click="() => {}"
        /> -->
        <menu-card
          label="休暇買上げ・繰越し"
          description="年度毎の休暇の買い上げ繰越しができます"
          @click="navigateToDayOffPurchaseCarryover"
        />
        <!-- <menu-card
          label="配乗船員一覧"
          description="船員単位で配乗に関する情報が見れます"
          @click="() => {}"
        />
        <menu-card
          label="配乗船舶一覧"
          description="船舶単位で配乗に関する情報が見れます"
          @click="() => {}"
        /> -->
      </div>
    </section-with-divider>
  </div>
</template>

<script>
import { ColorMixin } from "@/mixins";
import { createNamespacedHelpers } from "vuex";
import { HandleHttpErrorService } from "../utils/errors";
import CrewAssignmentAlertCard from "../components/CrewAssignmentAlertCard.vue";
import LabeledFlexSection from "../components/LabeledFlexSection.vue";
import SectionWithDivider from "../components/SectionWithDivider.vue";
import MenuCard from "../components/MenuCard.vue";

const { mapActions, mapGetters } = createNamespacedHelpers(
  "crewAssignmentManagement"
);
export default {
  name: "CrewAssignmentDashboard",
  components: {
    CrewAssignmentAlertCard,
    LabeledFlexSection,
    SectionWithDivider,
    MenuCard,
  },
  mixins: [ColorMixin],
  methods: {
    ...mapActions([
      "fetchEnterpriseManningVessels",
      "fetchEnterpriseManningVesselAlerts",
      "fetchEnterpriseCrewsAlerts",
      "fetchEnterpriseCrewAlertSettings",
    ]),
    /** 配乗一覧表遷移（別タブで開く） */
    navigateToManningSchedule() {
      const route = this.$router.resolve(
        "/enterprise/addon/crew-assignment-management/manning-schedule/overview"
      );
      window.open(route.href, "_blank");
    },
    /** 船舶単位配乗表遷移（別タブで開く） */
    navigateToVesselManning() {
      const route = this.$router.resolve(
        "/enterprise/addon/crew-assignment-management/manning-schedule/vessels"
      );
      window.open(route.href, "_blank");
    },
    /** 船員単位配乗表遷移（別タブで開く） */
    navigateToCrewManning() {
      const route = this.$router.resolve(
        "/enterprise/addon/crew-assignment-management/manning-schedule/crews"
      );
      window.open(route.href, "_blank");
    },
    /** 休暇買上げ・繰越し遷移 */
    navigateToDayOffPurchaseCarryover() {
      this.$router.push(
        "/enterprise/addon/crew-assignment-management/day-off-purchase-carryover"
      );
    },
    async fetchData() {
      const fetchEnterpriseManningVesselAlertsParams = {
        kinds: ["REPLACEMENT_CREW_NOT_ASSIGNED"],
      };

      const fetchEnterpriseCrewsAlertsParams = {
        kinds: [
          "DAY_OFF_REQUEST_DUPLICATED",
          "EMBARKATION_STANDBY",
          // "LICENSE_EXPIRED",
          // "CREW_NOT_SCHEDULED",
          "DISEMBARKATION_STANDBY",
        ],
      };

      try {
        this.$vs.loading({ color: this.AISEA_COLOR.BLUE });

        await Promise.all([
          this.fetchEnterpriseManningVesselAlerts(
            fetchEnterpriseManningVesselAlertsParams
          ),
          this.fetchEnterpriseCrewsAlerts(fetchEnterpriseCrewsAlertsParams),
          this.fetchEnterpriseCrewAlertSettings(),
        ]);
      } catch (error) {
        const message = HandleHttpErrorService.handleErrorNotificationMessage(
          error
        );
        /** @TODO エラー文言の修正（あれば） */
        this.$vs.notify({
          title: "通信に失敗しました",
          text: message,
          color: "danger",
        });
        return;
      } finally {
        this.$vs.loading.close();
      }
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters([
      "getManningVessels",
      "getManningVesselsAlerts",
      "getCrewAlerts",
      "getCrewAlertSettings",
    ]),
    /** 入替船員未登録 */
    manningVesselAlert() {
      return (
        this.getManningVesselsAlerts.find(
          alert => alert.alert_kind === "REPLACEMENT_CREW_NOT_ASSIGNED"
        ) || {}
      );
    },
    manningVesselAlertSetting() {
      return this.getCrewAlertSettings.find(
        setting => setting.kind === "REPLACEMENT_CREW_NOT_ASSIGNED"
      );
    },
    /** 休暇希望重複 */
    dayOffRequestDuplicatedAlert() {
      return (
        this.getCrewAlerts.find(
          alert => alert.alert_kind === "DAY_OFF_REQUEST_DUPLICATED"
        ) || {}
      );
    },
    dayOffRequestDuplicatedAlertSetting() {
      return this.getCrewAlertSettings.find(
        setting => setting.kind === "DAY_OFF_REQUEST_DUPLICATED"
      );
    },
    /** 乗船準備 */
    embarkationStandbyAlert() {
      return (
        this.getCrewAlerts.find(
          alert => alert.alert_kind === "EMBARKATION_STANDBY"
        ) || {}
      );
    },
    embarkationStandbyAlertSetting() {
      return this.getCrewAlertSettings.find(
        setting => setting.kind === "EMBARKATION_STANDBY"
      );
    },
    /** 資格期限 */
    licenseExpiredAlert() {
      return (
        this.getCrewAlerts.find(
          alert => alert.alert_kind === "LICENSE_EXPIRED"
        ) || {}
      );
    },
    licenseExpiredAlertSetting() {
      return this.getCrewAlertSettings.find(
        setting => setting.kind === "LICENSE_EXPIRED"
      );
    },
    /** 予定未入力 */
    crewCompatibilityAlert() {
      return (
        this.getCrewAlerts.find(
          alert => alert.alert_kind === "CREW_NOT_SCHEDULED"
        ) || {}
      );
    },
    crewCompatibilityAlertSetting() {
      return this.getCrewAlertSettings.find(
        setting => setting.kind === "CREW_NOT_SCHEDULED"
      );
    },
    /** 下船準備 */
    disembarkationStandbyAlert() {
      return (
        this.getCrewAlerts.find(
          alert => alert.alert_kind === "DISEMBARKATION_STANDBY"
        ) || {}
      );
    },
    disembarkationStandbyAlertSetting() {
      return this.getCrewAlertSettings.find(
        setting => setting.kind === "DISEMBARKATION_STANDBY"
      );
    },
  },
  created() {
    this.fetchData();
  },
  mounted() {
    let routerViewElement = document.getElementsByClassName("router-view");
    if (routerViewElement && routerViewElement[0]) {
      routerViewElement[0].style.padding = "2.2rem";
    }
  },
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/aisea/variables";

.crew-assignment-dashboard {
  display: flex;
  flex-direction: column;
  gap: 16px;

  .alert-wrapper {
    display: flex;
    align-items: center;
    gap: 32px;
    padding: 24px;
    overflow: hidden;

    ::v-deep .vx-card__body {
      padding: 0 !important;
    }
  }

  .menu-button-list {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 24px;
    flex-wrap: wrap;
    padding: 24px;
  }

  .header-title {
    padding: 18px 0px;
    font-size: 18px;
    font-weight: 600;
    font-family: $aisea-font-family;
    line-height: 26px;
    color: $aisea-dark-gray;
  }
}
</style>
